import { CheckboxTypes } from '@genial/components';

export const sortDirectionOptions: CheckboxTypes.Option[] = [
  { label: 'Crescente', value: 'asc' },
  { label: 'Decrescente', value: 'desc' },
];
